<template>
    <v-dialog v-model="dialog" scrollable max-width="800px" max-height="800px" persistent overlay-opacity="0.75">
      	<v-card class="elevation-0 grey darken-3">
			<v-toolbar color="blue-grey darken-3" dark dense elevation="0">
				<v-toolbar-title>Docs für:</v-toolbar-title>
				<v-text-field flat solo dense hide-details background-color="blue-grey darken-4" readonly :value="parentItem.name" class="mx-3"
				></v-text-field>  
				<v-spacer></v-spacer>
				<!-- <v-btn disabled plain small>ID: {{ item.id }}</v-btn>
				<v-btn ripple icon><v-icon color="yellow darken-3">mdi-star</v-icon></v-btn> -->
			</v-toolbar>
	        <!-- <v-card-text>
	        </v-card-text> -->
            <v-card-text style="max-height: 500px;">
          		<v-container v-if="loading || !loading">
	      	<v-list dark dense class="grey darken-3" ref="list">
				<template v-for="(item, index) in uploads">
		            <v-list-item :key="index" dense>
		              	<template>
					        <v-list-item-avatar size="40">
					          	<v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon>
					        </v-list-item-avatar>
			                <v-list-item-content>
								<v-list-item-title v-text="item.name"></v-list-item-title>
								<v-list-item-title v-text="item.type"></v-list-item-title>
								<v-list-item-subtitle>{{ item.lastModified | toJSDT }}</v-list-item-subtitle>
			                </v-list-item-content>
			                <v-list-item-action>
			                	<v-list-item-action-text class="ml-3">{{ item.size | toMB }}</v-list-item-action-text>
			                </v-list-item-action>
					        <v-list-item-avatar size="40" right>
								<v-progress-circular v-if="cannotRemove(item)" :rotate="360" :size="60" :width="5"
									:value="item.progress" class="no-transition"
									:color="isActiveUpload(index) ? 'warning' : 'teal'">
									{{ uploadProgress(index) }}
								</v-progress-circular>
									<!--:indeterminate="isActiveUpload(index)"-->
					          	<v-btn v-else icon @click="onRemove(index)"><v-icon color="red">cancel</v-icon></v-btn>
					        </v-list-item-avatar>
		              	</template>
	            	</v-list-item>
	            </template>
	      	</v-list>
	        	</v-container>
	        </v-card-text>
	        <!-- <v-card-text>
	        </v-card-text> -->
        	<v-card-actions>
        		<v-btn text class="warning mx-0 mb-2" @click="onCancel()">Beenden</v-btn>
				<v-spacer />
      			<v-btn text class="primary mx-0 mb-2" @click="onPickFiles()" :disabled="cannotPick()">Dateien auswählen</v-btn>
				<v-spacer />
            	<input type="file" multiple="multiple" id="uploads" style="display: none"
            		ref="files" accept=".jpg,.png,.xls,.xlsx,.csv,.pdf" @change="onFilesPicked">
      			<v-btn class="success mx-0 mb-2" @click="onUpload()" :disabled="cannotUpload()">Start Upload</v-btn>

        		<!-- <v-btn v-if="!error" text class="success mx-1 mb-2" :loading="loading" :disabled="loading || !dirty"
				 @click="onSubmit()">Speichern</v-btn>
        		<v-btn v-else text class="error mx-1 mb-2" disabled>{{ error }}</v-btn>
			    <v-spacer />
        		<v-btn v-if="!error && newItem" text class="primary mx-0 mb-2" :loading="loading" :disabled="loading || !dirty"
				 @click="onSubmit('new')">Speichern und Neu</v-btn> -->
        	</v-card-actions>
      	</v-card>
		<v-dialog v-model="showmessage">
			<v-toolbar dark color="warning" dense>
				<v-toolbar-title class="white--text">{{ message.title }}</v-toolbar-title>
			</v-toolbar>
			<v-card tile>
				<v-card-text color="red" v-html="message.msg"/>
				<v-card-actions>
					<v-spacer/>
					<v-btn color="blue" text @click="onMessageClose()">Ok</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
        <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay>
    </v-dialog>          
</template>
<script>

export default {
	name: "GenericUpload",
	components: {  },
	props: {
		modulData: {
			type: Object,
			required: true,
			default: null,
		},
	},
	data: () => ({
		dialog: false,
		loading: false,
		error: '',
		message: {},
		showmessage: false,
		cfgTable: {},
		cfgForms: [],
		item: {},
		icons: {
			'type:': { icon: 'not_listed_location', iconClass: 'grey red--text' },
			'type:application/pdf': { icon: 'picture_as_pdf', iconClass: 'pink accent-2 white--text' },
			'type:image/png': { icon: 'image', iconClass: 'teal white--text' },
			'type:image/jpeg': { icon: 'image', iconClass: 'teal white--text' },
			'type:text/csv': { icon: 'description', iconClass: 'red white--text' },
			'type:application/vnd.ms-excel': { icon: 'description', iconClass: 'blue white--text' },
			'type:application/msword': { icon: 'description', iconClass: 'blue white--text' },
			'type:image/jpg': { icon: 'image', iconClass: 'teal white--text' },
			'type:text/plain': { icon: 'description', iconClass: 'blue white--text' },
		},
		uploads: [],
		uploading: false,
		uploadActive: false,
		uploaded: false,
		hInterval: null,
		firstUndone: null,
		activeUpload: -1,
	}),
	computed: {
		currentProgress() {
			return this.$store.getters['files/getProgress']
		},
		parentItem() {
			return this.modulData.meta.item
		},
		parentRefCol() {
			return this.modulData.meta.refcol
		},
	},
	methods: {
		closeDialog(event) {
			this.loading = false
			this.dialog = false
			//this.$store.commit('generic/resetUploadItems')
			this.$emit(event)
		},
		msgError(errorMsg) {
			this.loading = false
			this.error = "Eingaben konnten nicht gespeichert werden"
			let self = this
			setTimeout(() => {
				self.error = ''
			}, 5000);
			this.message = '<code>' + JSON.stringify(errorMsg).substring(0, 200) + '</code>'
			this.showmessage = true
		},
		/*onSubmit(opt) {
			this.uploadFiles(opt)
		},*/
		onCancel() {
			this.uploading = false
			if (this.hInterval)	clearInterval(this.hInterval)
			this.hInterval = null
			//console.log('upload canceled')
			if(this.uploaded) { this.closeDialog('submitted') } else { this.closeDialog('cancelled') }
		},
		onMessageClose() {
			if(this.message.status == 403) this.onCancel()
			this.message = {}
			this.showmessage = false			
		},
		async uploadAFile() {
			this.activeUpload = this.uploads.findIndex(item => item.progress !== 'ok')
			if(this.activeUpload >= 0) {
				let formData = new FormData()
				formData.append('file', this.uploads[this.activeUpload])
				formData.append('time', this.uploads[this.activeUpload].lastModified)
				formData.append('mime', this.uploads[this.activeUpload].type)
				formData.append('refcol', this.parentRefCol)
				formData.append('refid', this.parentItem.id)
				this.uploadActive = true
				//console.table(Object.fromEntries(formData))
				try {
					this.uploaded = true
					await this.$store.dispatch('generic/uploadFile', formData)
					let upload = this.uploads[this.activeUpload]
					upload.progress = 'ok'
					this.uploads.splice(this.activeUpload, 1, upload)					
					this.$store.commit('generic/setProgress', 0)
				} catch (error) {
					console.log(error)
					this.uploads[this.activeUpload].progress = '--'
					this.uploading = false
					clearInterval(this.hInterval)
					this.hInterval = null
					console.log('upload stopped')
				} finally {
					this.activeUpload = -1
					this.uploadActive = false
				}
			} else {
				this.uploading = false
				clearInterval(this.hInterval)
				this.hInterval = null
				//console.log('upload stopped')
			}
		},
		getCfgs() {
			const param = {
				table_name: this.modulData.meta.subtable,
				reftable: this.modulData.meta.tablename,
			}
			this.cfgTable = this.$store.getters['core/getCfgTable'](param)
			this.cfgForms = this.$store.getters['core/getCfgForms'](param)
		},
		onPickFiles() {
			this.$refs.files.click()
		},
		onFilesPicked(e) {
			const files = e.target.files
			if(!files.length) return;
			this.uploads = this.uploads.filter(x => x.progress !== 'ok')
			for(var file of files) {
				if(this.uploads.find(x => x.name == file.name) === undefined) {
					this.uploads.push(file)
				}
			}
			for(var upload of this.uploads) {
				upload.icon = this.icons['type:' + upload.type].icon
				upload.iconClass = this.icons['type:' + upload.type].iconClass
				upload.progress = 0//Math.floor(Math.random() * 100);
			}
			this.$refs.files.value = []
		},
		uploadCompleted() {

		},
		uploadFile() {
			this.activeUpload = this.uploads.findIndex(item => item.progress !== 'ok')
			if(this.activeUpload >= 0) {
				let formData = new FormData()
				formData.append('file', this.uploads[this.activeUpload])
				formData.append('time', this.uploads[this.activeUpload].lastModified)
				formData.append('mime', this.uploads[this.activeUpload].type)
				this.uploadActive = true
				//var self = this
				//console.log(formData.getAll())
				this.$store.dispatch('files/uploadFile', formData)
				.then((response) => {
					let upload = this.uploads[this.activeUpload]
					upload.progress = 'ok'
					this.uploads.splice(this.activeUpload, 1, upload)					
					this.activeUpload = -1
					this.$store.commit('files/setProgress', 0)
					this.uploadActive = false
				})
				.catch((error) => {
					console.log(error)
					this.uploads[this.activeUpload].progress = '--'
					this.activeUpload = -1
					this.uploadActive = false
					this.uploading = false
					clearInterval(this.hInterval)
					this.hInterval = null
					console.log('upload stopped')
				})
			} else {
				this.uploading = false
				clearInterval(this.hInterval)
				this.hInterval = null
				//console.log('upload stopped')
			}
		},
		onUpload() {
			if (!this.hInterval) {
				//console.log('upload started')
				this.uploading = true
				this.hInterval = setInterval(() => {
					if(!this.uploadActive && this.uploading) this.uploadAFile()
				}, 200)
			}
		},
		onRemove(index) {
			this.uploads.splice(index, 1); 
		},
		getIcon(item) {
			return this.icons[item.type]
		},
		cannotUpload() {
			let undone = this.uploads.reduce((total, x) => x.progress !== 'ok', 0)
			return (this.uploading || (!undone))
		},
		cannotPick() {
			return this.uploading
		},
		cannotRemove(item) {
			return this.uploading || (!!(item.progress === 'ok'))
		},
		isActiveUpload(index) {
			return index == this.activeUpload
		},
		uploadProgress(index) {
			return (index == this.activeUpload) ? this.currentProgress : this.uploads[index].progress
		},
	},
	beforeMount() {
		this.getCfgs()
		this.dialog = true
	},
	mounted() {
		//console.log('parentItemData:', this.parentItem)
		//console.log('parentItemRef:', this.modulData.meta.refcol)
		//console.log(JSON.stringify(this.modulData))
	},
	watch: {
		currentProgress() {
			if((this.activeUpload >= 0) && this.currentProgress > (this.uploads[this.activeUpload].progress + 10)) {
				let upload = this.uploads[this.activeUpload]
				upload.progress = this.currentProgress
				//this.uploads.splice(this.activeUpload, 1, upload)
				this.$set(this.uploads, this.activeUpload, upload)
				//Vue.set(this.myArray, index, newValue)
				//Vue.set(this.myObject, key, value)
				//Vue.delete(this.myObject, key)
			}
		}
	},
}  
</script>

<style>
.theme--dark.v-label {
    color: rgba(255, 255, 255, 0.3);
}
.no-transition .progress-circular__overlay {
  transition: all 0.01s ease-in-out;
}

</style>
